import { useEffect, useState } from 'react'
import { Box, Button, Grid, IconButton, Paper, Typography } from '@mui/material'
import Page from '../layout/Page'
import { FeatureFlags } from '../config/config'
import { getSiteConfig } from '../community/siteProvider'
import { Stack } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import { AllInclusive, FactCheck, HealthAndSafety } from '@mui/icons-material'
import HomePageCarousel from './HeroCarousel/HomePageCarousel'
import QuickLinks from './QuickLinks'
import './HubLanding.css'

export default function CommunityHubLanding(props = {}) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const initializePage = async () => {
    startLoading()
    // 
    stopLoading()
  }

  useEffect(() => {
    initializePage()
  }, [])

  const navButtons = () => {
    return [
      { l: 'Quality Hub', t: '/quality-hub/news', i: <FactCheck /> },
      { l: 'Safety Hub', t: '/safety-community-hub/news', i: <HealthAndSafety /> },
      { l: 'Sustainability Hub', t: '/sustainability-hub/news', i: <AllInclusive /> }
    ].map((b, index) => {
      const alpha = '1'
      const background = ({
        0: `linear-gradient(90deg, rgb(223, 48, 33, ${alpha}), rgb(229, 115, 45, ${alpha}))`,
        1: `linear-gradient(90deg, rgb(229, 115, 45, ${alpha}), rgb(216, 179, 94, ${alpha}))`,
        2: `linear-gradient(90deg, rgb(216, 179, 94, ${alpha}), rgb(186, 222, 229, ${alpha}))`,
      })[index]
      const color = 'rgb(255,255,255)'
      return <Box key={b.l.split(' ')[0]} component="button" sx={
        { color, p: 1, flexGrow: '1', justifyItems: 'center', border: '0px solid #CCC', borderRadius: '8px', background }
      } onClick={() => navigate(b.t)} className="navBtn">
        <Stack direction='row' columnGap={2}>{b.i}<Typography variant='body1'>{b.l}</Typography></Stack>
      </Box>
    })
  }

  return (
    <Page {...props} isLoading={isLoading}
    >

      <Paper
        component="form"
        sx={{ backgroundColor: 'transparent', padding: 'unset', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: 'unset' }}
      >
        <Grid container rowGap={1} height='100%'>
          <Grid item xs={12} sx={{
            height: 'calc(60vh - 75px)', // vh - header/footer
            textAlign: 'center',
            alignContent: 'center',
            // border: '1px dashed #CCC'
          }}>
            <HomePageCarousel
              cycleDurationMs={8000}
            />
          </Grid>
          <Grid item xs={12} padding='2' sx={{
              height: 'calc(5vh',
            }}>
            <Stack direction='row' columnGap={2} justifyContent='space-between'>
              {navButtons()}
            </Stack>
          </Grid>
          <Grid item xs={12} sx={{
            minHeight: 'calc(40vh - 75px)', // vh - header/footer
            textAlign: 'center',
            // border: '1px dashed #CCC'
          }}>

            <QuickLinks />

          </Grid>
        </Grid>

      </Paper>
    </Page>
  )
}